module.exports = __webpack_public_path__ + "static/media/searchIcon.50626a87.svg";